import React from 'react';
import Scores from '../scores';
import TestDate from '../test-date';

const ActPlanForm = () => (
  <>
    <TestDate />
    <Scores min={1} max={32} />
  </>
);

export default ActPlanForm;
